import { render, staticRenderFns } from "./thankUpgradePopup.vue?vue&type=template&id=632ca163&scoped=true&"
import script from "./thankUpgradePopup.vue?vue&type=script&lang=js&"
export * from "./thankUpgradePopup.vue?vue&type=script&lang=js&"
import style0 from "../less/thankPopup.less?vue&type=style&index=0&id=632ca163&scoped=true&lang=css&"
import style1 from "./thankUpgradePopup.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ca163",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632ca163')) {
      api.createRecord('632ca163', component.options)
    } else {
      api.reload('632ca163', component.options)
    }
    module.hot.accept("./thankUpgradePopup.vue?vue&type=template&id=632ca163&scoped=true&", function () {
      api.rerender('632ca163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/paymentPlans/thankUpgradePopup/thankUpgradePopup.vue"
export default component.exports